import common from 'store/modules/common/api'

export const api = {
  ...common.softDeleteApiMethods('Bottles'),
  startExport: (filter) => common.httpClient.post(`/api/services/app/Bottles/StartExport`, filter, common.options()).then(r => common.processResponse(r)),
  quickSell: (soldByChannel, bottleIds) => common.httpClient.post(`/api/services/app/Bottles/QuickSell`, { soldByChannel, bottleIds }, common.options()).then(r => common.processResponse(r)),
}
